import { Component, Input } from '@angular/core';
import { AuthService } from "../../services/auth/auth.service";
import { VehicleInfoService } from '../../services/nonanon/vehicle/vehicle-info.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'client-individual',
    templateUrl: './client-individual.component.html'
})

export class ClientIndividualComponent  {
  @Input() clientInfo: any;

    //onVehicleInfoChanged: Subscription;

    constructor(
      private authService: AuthService) { }


    //Security items for viewing owner information
    canViewClientNumber: boolean = false;
    canViewClientName: boolean = false;
    canViewMailingAddress: boolean = false;
    canViewResidentialAddress: boolean = false;
    portal_CanViewClientDOB: boolean = false;
    canViewGender: boolean = false;
    canViewContactNumber: boolean = false;
    canViewDriverLicenceNumber: boolean = false;
    canViewDriverLicenceStatus: boolean = false;

    residentalSameAsMailing: boolean;
    residentalSameAsMailingResponseString: string = "";

  ngOnInit() {

      //Load security items for viewing owner information
      this.canViewClientNumber = this.authService.getUser().canViewClientNumber;
      this.canViewClientName = this.authService.getUser().canViewClientName;
      this.canViewMailingAddress = this.authService.getUser().canViewMailingAddress;
      this.canViewResidentialAddress = this.authService.getUser().canViewResidentialAddress;
      this.portal_CanViewClientDOB = this.authService.getUser().portal_CanViewClientDOB;
      this.canViewGender = this.authService.getUser().canViewGender;
      this.canViewContactNumber = this.authService.getUser().canViewContactNumber;
      this.canViewDriverLicenceNumber = this.authService.getUser().canViewDriverLicenceNumber;
      this.canViewDriverLicenceStatus = this.authService.getUser().canViewDriverLicenceStatus;
      this.residentalSameAsMailing = this.clientInfo.residentalSameAsMailing;

      //if (this.residentalSameAsMailing == true) {
      //  this.residentalSameAsMailingResponseString = "Same as Mailing Address";
      //}
  }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/shared/client-individual.component.ts